module.exports = __webpack_public_path__ + "img/ic_gexinghuaguanli.481af6b9.svg";